import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=25c9975c&scoped=true&lang=pug&"
import script from "./PostForm.vue?vue&type=script&lang=ts&"
export * from "./PostForm.vue?vue&type=script&lang=ts&"
import style0 from "./PostForm.vue?vue&type=style&index=0&id=25c9975c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9975c",
  null
  
)

export default component.exports